export function getBaseUrl(): string {
  if (typeof window !== 'undefined') {
    console.log("base from basePath.ts", window.location.pathname);
    return window.location.pathname.includes('/accreditation-ui') ? '/accreditation-ui/' : '/';
  }
  console.log("base from basePath.ts", '/');
  return '/';
}
